export class AclDataObject {
	/**
	 * @param {string[]} [permissions=[]] - User permissions.
	 * @param {string} [userType=''] - User type.
	 * @param {boolean} [isGuest=false] - Is user a guest user.
	 * @param {Object} [additionalData={}] - Additional user data that can be used in ACL checks.
	 */
	constructor(permissions = [], userType = '', isGuest = false, additionalData = {}) {
		this.permissions = permissions;
		this.userType = userType;
		this.isGuest = isGuest;
		this.additionalData = additionalData;
	}
}

export class AclCheckDataObject {
	/**
	 * @param {string[]} [permissions=[]] - List of permissions required for access. Checking will be done using the
	 * 'acl_check_mode' acl config option.
	 * @param {string[]} [userTypes=[]] - List of user types that should have access.
	 * @param {boolean} [forGuest] - Flag that specifies if guest user should have access. If not defined, checking for
	 * guest will be skipped.
	 */
	constructor(permissions = [], userTypes = [], forGuest) {
		this.permissions = permissions;
		this.userTypes = userTypes;
		this.forGuest = forGuest;
	}
}